<template>
  <v-app id="inspire">
    <v-main>
      <v-container fluid fill-height>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12 mt-n16">
              <v-toolbar color="primary" dark flat>
                <v-toolbar-title>Login with Intract app account</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-tooltip bottom>
                  <template>
                    <v-btn icon large target="_blank">
                      <v-icon>mdi-code-tags</v-icon>
                    </v-btn>
                  </template>
                  <span>Source</span>
                </v-tooltip>
              </v-toolbar>
              <v-form @submit="login">
                <v-card-text>
                  <p v-if="formErrors.genError" class="form-error">{{ formErrors.genError }}</p>
                  <v-text-field
                    label="Phone"
                    v-model="phone"
                    prepend-icon="mdi-account"
                    :error="formErrors.phoneError != null"
                    :error-messages="formErrors.phoneError"
                    type="text"
                  ></v-text-field>
                  <v-text-field
                    id="password"
                    label="Password"
                    v-model="password"
                    :error="formErrors.passwordError != null"
                    :error-messages="formErrors.passwordError"
                    prepend-icon="mdi-lock"
                    type="password"
                  ></v-text-field>
                </v-card-text>
                <div class="text-center">
                  <v-progress-circular v-if="isLoading" indeterminate size="30"></v-progress-circular>

                  <v-btn color="primary" type="submit" class="mb-3" v-else>Login</v-btn>
                </div>
              </v-form>
            </v-card>
          </v-col>
        </v-row>
        <v-overlay :value="isLoading">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-snackbar v-model="snackbar.visible">
          {{ snackbar.text }}
          <template>
            <v-btn color="pink" text @click="snackbar.visible = false">Close</v-btn>
          </template>
        </v-snackbar>
      </v-container>
    </v-main>
  </v-app>
</template>


<script>
import { mapActions, mapGetters } from "vuex";
import authApi from "@api/auth/base";
import Helper from "@utils/misc";

// import ApiError from '@utils/helper_classes';
export default {
  name: "Login",
  data() {
    return {
      phone: "",
      password: "",
      formErrors: {
        genError: null,
        phoneError: null,
        passwordError: null
      },
      snackbar: {
        visible: false,
        text: ""
      }
    };
  },
  computed: {
    ...mapGetters(["isLoading", "currentUser", "currentInstitution", "accessToken"])
  },
  methods: {
    ...mapActions(["setLoading", "setTokens", "setCurrentUser", "setCurrentInstitution"]),
    // checks for any invalid or empty field
    validateFields() {
      Object.keys(this.formErrors).forEach(v => (this.formErrors[v] = null));
      if (this.phone == "") {
        this.formErrors.phoneError = "This field is required";
        return false;
      }
      if (this.password == "") {
        this.formErrors.passwordError = "This field is required";
        return false;
      }

      return true;
    },
    async login(e) {
      e.preventDefault();
      if (!this.validateFields()) return;
      this.setLoading(true);
      //creates token from phone and password
      let tokens = await authApi.createToken({
        username: this.phone,
        password: this.password
      });

      // handle token errors
      if (!Helper.handleErrors(tokens, this.handleApiError))
        return;

      // set tokens in state
      await this.setTokens(tokens);

      // get currentUser
      let currentUser = await authApi.getMyDetails(tokens.access);

      // handle currentUser errors
      if (currentUser instanceof Error) {
        this.setLoading(false);
        this.snackbar.text = "There was a server error. Please, try again!";
        this.snackbar.visible = true;
        return;
      }

      //set user in state
      await this.setCurrentUser(currentUser);
      
      // get currentInstitution
      let currentInstitution = await authApi.getInstitutionDetails(tokens.access, currentUser.institution.id);

      // handle currentInstitution errors
      if (currentInstitution instanceof Error) {
        this.snackbar.text = "There was a server error. Please, try again!";
        this.snackbar.visible = true;
        return;
      }

      //set institution in state
      await this.setCurrentInstitution(currentInstitution);
      this.setLoading(false);

      if (this.currentUser !== null && this.$route.query.next != null) {
        this.$router.push(this.$route.query.next);
      } else {
        this.$router.push("/");
      }
    },
    handleApiError(err) {
      console.log(err);
      this.setLoading(false);
      if (err.response) {
        if (err.response.status == 401) {
          this.formErrors.genError = "Incorrect phone or password";
        }
      }
    }
  },
  created() {
    // if user on login page and currentUser != null, navigate to home '/'
    if (this.currentUser != null) this.$router.push("/");
  }
};
</script>

<style scoped>
</style>